import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'iho-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  imports: [NgIf],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonComponent {

  @Input() width!: string
  @Input() height!: string
  @Input() type: 'circle' | 'rectangle' | 'maximum' = 'rectangle'
  @Input() customClass = ''
}
